import {
  useGetLoanStatementQuery,
  useLazyDownloadLoanStatementQuery,
} from "@/modules/loan/services";
import { DownloadExtension } from "@/shared/common/constants";
import { DownloadType } from "@/shared/common/enums";
import type { IError } from "@/shared/common/types";
import { FilterPanel, Statement } from "@/shared/components";
import { useFilters } from "@/shared/hooks";
import { downloadFileFromUrl } from "@/shared/utils";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export const LoanStatement = () => {
  const { t } = useTranslation();
  const { loanId = "" } = useParams();
  const { filters, setFilters, defaultFilters } = useFilters();

  const [
    downloadLoanStatement,
    { isFetching: isDownloading },
  ] = useLazyDownloadLoanStatementQuery();

  const {
    data: loanStatement,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetLoanStatementQuery({
    id: loanId,
    ...filters,
  }, {
    refetchOnMountOrArgChange: true,
  });

  const onDownload = (exportFormat: DownloadType) => {
    downloadLoanStatement({
      id: loanId,
      exportFormat,
      ...filters,
    })
      .unwrap()
      .then((response) => {
        if (response?.url) {
          const fileType = DownloadExtension[exportFormat];
          const name = `Loan-statements-${filters.startDate}-${filters.endDate}.${fileType}`;
          downloadFileFromUrl(response.url, name);
        }
      });
  };

  const actions = [
    {
      label: t("general.pdf"),
      type: DownloadType.Pdf,
    }
  ];

  return (
    <Statement
      onDownload={onDownload}
      isFetching={isFetching}
      isError={isError}
      actions={actions}
      isDownloading={isDownloading}
      error={error as IError}
      refetch={refetch}
      statement={loanStatement}
    >
      <FilterPanel
        filters={filters}
        setFilters={setFilters}
        defaultFilters={defaultFilters}
      />
    </Statement>
  );
};
